var React = require('react');

function Loading (props) {
    return React.createElement("svg",props,React.createElement("circle",{"cx":"50","cy":"50","fill":"none","ngAttrStroke":"{{config.color}}","ngAttrStrokeWidth":"{{config.width}}","ngAttrR":"{{config.radius}}","ngAttrStrokeDasharray":"{{config.dasharray}}","stroke":"#084782","strokeWidth":"2","r":"24","strokeDasharray":"70.68583470577033 25.561944901923447","transform":"rotate(180 50 50)"},React.createElement("animateTransform",{"attributeName":"transform","type":"rotate","calcMode":"linear","values":"0 50 50;360 50 50","keyTimes":"0;1","dur":"1.5s","begin":"0s","repeatCount":"indefinite"})));
}

Loading.displayName = "Loading";

Loading.defaultProps = {"width":"200px","height":"200px","viewBox":"0 0 100 100","preserveAspectRatio":"xMidYMid","className":"lds-rolling","style":{"background":"none"}};

module.exports = Loading;

Loading.default = Loading;



//////////////////
// WEBPACK FOOTER
// ./src/app/icons/loading.svg
// module id = 88
// module chunks = 0